/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodOverridableConfiguration } from './PaymentMethodOverridableConfiguration';
import {
    PaymentMethodOverridableConfigurationFromJSON,
    PaymentMethodOverridableConfigurationFromJSONTyped,
    PaymentMethodOverridableConfigurationToJSON,
    PaymentMethodOverridableConfigurationToJSONTyped,
} from './PaymentMethodOverridableConfiguration';

/**
 * 
 * @export
 * @interface PaymentMethodLocationConnectionDto
 */
export interface PaymentMethodLocationConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationConnectionDto
     */
    externalId: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodLocationConnectionDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationConnectionDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodLocationConnectionDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationConnectionDto
     */
    locationName: string;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodLocationConnectionDto
     */
    enabledInApps?: Set<FavritApp>;
    /**
     * 
     * @type {PaymentMethodOverridableConfiguration}
     * @memberof PaymentMethodLocationConnectionDto
     */
    overridableConfiguration?: PaymentMethodOverridableConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodLocationConnectionDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodLocationConnectionDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodLocationConnectionDto
     */
    activeTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationConnectionDto
     */
    createdByUserEmail: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodLocationConnectionDto
     */
    updatedByUserEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodLocationConnectionDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodLocationConnectionDto
     */
    updated: Date;
}



/**
 * Check if a given object implements the PaymentMethodLocationConnectionDto interface.
 */
export function instanceOfPaymentMethodLocationConnectionDto(value: object): value is PaymentMethodLocationConnectionDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('createdByUserEmail' in value) || value['createdByUserEmail'] === undefined) return false;
    if (!('updatedByUserEmail' in value) || value['updatedByUserEmail'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function PaymentMethodLocationConnectionDtoFromJSON(json: any): PaymentMethodLocationConnectionDto {
    return PaymentMethodLocationConnectionDtoFromJSONTyped(json, false);
}

export function PaymentMethodLocationConnectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodLocationConnectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'locationId': json['locationId'],
        'locationName': json['locationName'],
        'enabledInApps': json['enabledInApps'] == null ? undefined : (new Set((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'overridableConfiguration': json['overridableConfiguration'] == null ? undefined : PaymentMethodOverridableConfigurationFromJSON(json['overridableConfiguration']),
        'isActive': json['isActive'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'createdByUserEmail': json['createdByUserEmail'],
        'updatedByUserEmail': json['updatedByUserEmail'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function PaymentMethodLocationConnectionDtoToJSON(json: any): PaymentMethodLocationConnectionDto {
    return PaymentMethodLocationConnectionDtoToJSONTyped(json, false);
}

export function PaymentMethodLocationConnectionDtoToJSONTyped(value?: PaymentMethodLocationConnectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'locationId': value['locationId'],
        'locationName': value['locationName'],
        'enabledInApps': value['enabledInApps'] == null ? undefined : (Array.from(value['enabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'overridableConfiguration': PaymentMethodOverridableConfigurationToJSON(value['overridableConfiguration']),
        'isActive': value['isActive'],
        'activeFrom': value['activeFrom'].toISOString(),
        'activeTo': value['activeTo'] == null ? value['activeTo'] : value['activeTo'].toISOString(),
        'createdByUserEmail': value['createdByUserEmail'],
        'updatedByUserEmail': value['updatedByUserEmail'],
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

